const HitEvent = ({ event, getPlayerName, getTeamAbbreviation, homeTeamId, awayTeamId }) => (
    <div className="flex items-center mb-2">
        <span className="text-sm font-semibold text-gray-700 mr-2">Time:</span>
        <span className="text-sm text-gray-900 mr-2">{event.timeInPeriod}</span>
        <span className="text-sm font-semibold text-gray-700 mr-2">Period:</span>
        <span className="text-sm text-gray-900 mr-2">{event.periodDescriptor.number}</span>
        <span className="text-sm font-semibold text-gray-700 mr-2">{getPlayerName(event.details?.hittingPlayerId)}</span>
        {event.details?.hittingPlayerId && (
            <img
                src={`https://assets.nhle.com/mugs/nhl/20242025/${getTeamAbbreviation(event.details?.eventOwnerTeamId)}/${event.details?.hittingPlayerId}.png`}
                alt={getPlayerName(event.details?.hittingPlayerId)}
                className="inline-block ml-2 w-8 h-8 rounded-full"
            />
        )}
        <span className="text-sm font-semibold text-gray-700 mx-2">Hit On</span>
        {event.details?.hitteePlayerId && (
            <img
                src={`https://assets.nhle.com/mugs/nhl/20242025/${getTeamAbbreviation(event.details?.eventOwnerTeamId === homeTeamId ? awayTeamId : homeTeamId)}/${event.details?.hitteePlayerId}.png`}
                alt={getPlayerName(event.details?.hitteePlayerId)}
                className="inline-block ml-2 w-8 h-8 rounded-full"
            />
        )}
        <span className="text-sm font-semibold text-gray-700 ml-2">{getPlayerName(event.details?.hitteePlayerId)}</span>
    </div>
);

export default HitEvent;